import { DropdownMenuWithButton, DropdownButton } from '@ui-components/neo.tax';
import React from 'react';

import { DropdownFormType } from './forms.types';

export const DropdownForm = ({ form }: { form: DropdownFormType }): React.ReactElement | null => (
  <DropdownMenuWithButton<string | number, typeof DropdownButton>
    options={form.options}
    placeholder={form.placeholder || ''}
    value={form.value || ''}
    disabled={form.disabled}
    id={form.id}
    errorText={form.validator?.(form.value)}
    onChange={form.onChange.bind(form)}
    button={form.button || null}
  />
);
